import styled, { css } from 'styled-components';
import { media } from '@carvana/stc-styles';

const buttonCss = css`
  appearance: none;
  align-items: center;
  background-color: ${({ disabled }) => (disabled ? 'rgba(0, 0, 0, 0.20)' : 'transparent')};
  border-radius: 2px;
  border: 0;
  box-sizing: border-box;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: inline-flex;
  font-family: 'Brandon Text';
  font-size: 14px;
  font-weight: bold;
  justify-content: center;
  line-height: 1.4em;
  margin: 0;
  min-height: 36px;
  min-width: 88px;
  padding: 0;
  pointer-events: ${props => props.disabled && 'none'};
  position: relative;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  user-select: none;
  vertical-align: middle;
`;

const ButtonBase = styled.button`
  ${buttonCss}
`;

export const CtaButton = styled(ButtonBase)`
  && {
    font-weight: 600;
    padding: ${props => props.theme.spacing.px.sm};
    background: ${props => props.theme.carvana.blue.primary};
    font-size: 14px;
    color: #ffffff;
    min-width: 180px;
    height: 56px;
    border-radius: 3px;
    font-family: ${props => props.theme.v2.typography.family};

    &:hover {
      ${media.sm`
        background: ${props => props.theme.carvana.blue.hover};
      `}
    }

    &[disabled] {
      background: ${props => props.theme.carvana.gray.light};
      color: ${props => props.theme.carvana.gray.medium};
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.07);
      border: none;
    }
  }
`;

export const CtaButtonShort = styled(CtaButton)`
  && {
    height: 39px;
  }
`;

export const Rule = styled.div`
  width: 26px;
  height: 4px;
  background-color: ${({ theme }) => theme.carvana.yellow.primary};
  margin-bottom: 15px;
`;

const CtaButtonOutline = styled(CtaButton)`
  && {
    background: ${props => props.theme.carvana.white.primary};
    color: ${props => props.theme.carvana.blue.primary};
    border: 1px solid ${props => props.theme.carvana.blue.primary};
    border-radius: 3px;

    &:hover {
      ${media.sm`
        border: 1px solid ${props => props.theme.carvana.blue.hover};
        color: ${props => props.theme.carvana.white.primary};
      `}
    }
  }
`;

export const CtaButtonShortOutline = styled(CtaButtonOutline)`
  && {
    height: 39px;
  }
`;
